import i18n from '@/plugins/vue-i18n';
import { isEmpty } from 'lodash';

/**
 *
 * @param {Object} RORO The RORO wrapper.
 * @param {Object} RORO.product The product being modelled that the tooltip should be generated for.
 * @returns {Array<String>} The applicable tooltip messages for the provided product, or an empty array when none are applicable.
 */
const getProductModellingAlertsTooltip = ({ product }) => {
  if (!product?.productModellingAlerts) {
    return [];
  }

  const translationPrefix = 'productModellingPage.productModellingAlertsTooltips';

  const tooltipMessages = Object.entries(product.productModellingAlerts)
    .filter(entry => entry[1] === true)
    .map(entry => i18n.t(`${translationPrefix}.${entry[0]}`));

  return tooltipMessages;
};

/**
 *
 * @param {Object} columns All columns in the grid that are planned to be rendered
 * @param {Object} filterPatterns = List of regexs that are used to match which columns should be used.
 * @returns {Array<Object>} The original columns object, now filtered to exclude any column that matched the pattern
 */
const applyColumnFilters = (columns, filterPatterns = []) => {
  if (isEmpty(filterPatterns)) {
    return columns;
  }

  const regexPatterns = filterPatterns.map(pattern => new RegExp(pattern));

  const filteredColumns = columns
    .map(column => ({
      ...column,
      ...(column.children && { children: applyColumnFilters(column.children, filterPatterns) }),
    }))
    .filter(
      column =>
        !column.colId ||
        regexPatterns.some(regex => regex.test(column.colId)) ||
        column.children?.length > 0
    );

  return filteredColumns;
};

export default { getProductModellingAlertsTooltip, applyColumnFilters };
